import { Col, Modal, Row, Table } from 'react-bootstrap'
import { CustomButton } from '../../../../components/CustomButton'
import { XCircleFill } from 'react-bootstrap-icons'
import { Center } from '../../../../components/Center'

export function ModalCreatedAddressInfo({
  isOpen,
  onClose,
  alreadyCreatedAddresses,
}) {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="custom-modalzpl"
      size="lg"
      centered
    >
      <Modal.Body>
        <h1>Log dos Endereços</h1>

        <Row>
          <Col>
            <Center>
              <p>
                Os seguintes endereços <strong>NÃO</strong> foram criados, pois
                já existem no banco de dados:
              </p>
            </Center>

            <Table>
              <thead>
                <tr>
                  <th>Cód. End.</th>
                  <th>Depósito</th>
                  <th>Rua</th>
                  <th>Prédio</th>
                  <th>Nível</th>
                  <th>Apartamento</th>
                </tr>
              </thead>

              <tbody>
                {alreadyCreatedAddresses.map((address) => (
                  <tr>
                    <td>{address.codendereco}</td>
                    <td>{address.deposito}</td>
                    <td>{address.rua}</td>
                    <td>{address.predio}</td>
                    <td>{address.nivel}</td>
                    <td>{address.apto}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          title="Fechar"
          color="#dc0f0f"
          onClick={onClose}
        >
          <XCircleFill />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
